/** @format */
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { useTranslation } from 'react-i18next';
import { cardServices } from '../../../../Services/card.services';
import SpinnerLoading from '../../../Common/SpinnerLoading';

const CardsTable = ({ selectedItems, setSelectedItems }) => {
	const { t: translator } = useTranslation();

	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);
		cardServices
			.getAllCards()
			.then(res => {
				setData(res.data.data);
				setIsLoading(false);
			})
			.catch(err => console.log(err));
	}, []);

	const handleOnSelect = (row, isSelect) => {
		if (isSelect) {
			setSelectedItems(prevValue => [...prevValue, row.creditCardId]);
		} else {
			setSelectedItems(prevValue =>
				prevValue.filter(p => p !== row.creditCardId),
			);
		}
	};

	function actionFormatter(cell, row, rowIndex, formatExtraData) {
		return (
			<div className='action'>
				<label className='labelCont'>
					<input
						type='checkbox'
						name='workingMode'
						checked={
							formatExtraData.length > 0 &&
							formatExtraData.find(x => x === row.creditCardId)
						}
						onChange={e => handleOnSelect(row, e.target.checked)}
					/>
					<span className='checkmark'></span>
				</label>
			</div>
		);
	}

	const handleOnSelectAll = (isSelect, rows) => {
		if (isSelect) {
			setSelectedItems(data.map(x => x.creditCardId));
		} else {
			setSelectedItems([]);
		}
	};

	function actionHeaderFormatter(cell, rows) {
		return (
			<div className='action'>
				<label className='labelCont'>
					<input
						type='checkbox'
						name='workingMode'
						checked={selectedItems.length === data.length && data.length > 0}
						onChange={e => handleOnSelectAll(e.target.checked)}
					/>
					<span className='checkmark'></span>
				</label>
			</div>
		);
	}

	const columns = [
		{
			dataField: 'creditCardId',
			text: '',
			headerStyle: (colum, colIndex) => {
				return { width: '50px', textAlign: 'center' };
			},
			formatter: actionFormatter,
			headerFormatter: actionHeaderFormatter,
			formatExtraData: selectedItems,

			// hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
		},
		{
			dataField: 'name',
			text: translator('Administration-CardTypes-CardName'),
		},
	];

	return (
		<>
			<legend className='scheduler-border mb-3'>
				{translator('TenantPaymentMethod-Cards')}
			</legend>
			{isLoading ? (
				<div className='dashboard-card-spinner'>
					<SpinnerLoading />
				</div>
			) : (
				<BootstrapTable
					keyField='creditCardId'
					data={data}
					columns={columns}
					rowClasses='boostrap-table-row'
					// rowEvents={rowEvents}
					noDataIndication={translator('No-Data')}
					// pagination={paginationFactory({})}
					// onTableChange={onTableChange}
				/>
			)}
		</>
	);
};

export default CardsTable;
